export default __webpack_public_path__ + "static/media/hobbies.6dd1da77.jpg";